import { createClient } from '@supabase/supabase-js';
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;
if (!supabaseUrl || !supabaseAnonKey) {
    console.error('Missing Supabase environment variables:', {
        url: !!supabaseUrl,
        key: !!supabaseAnonKey,
    });
    throw new Error('Missing Supabase environment variables');
}
console.log('Supabase configuration:', {
    url: supabaseUrl,
    keyLength: supabaseAnonKey?.length,
});
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
    auth: {
        autoRefreshToken: true,
        persistSession: true,
    },
    global: {
        headers: {
            'x-application-name': 'moriden-setsubi',
        },
    },
    db: {
        schema: 'public',
    },
    realtime: {
        params: {
            eventsPerSecond: 2,
        },
    },
});
// Test connection with better error handling
(async () => {
    try {
        const { count, error } = await supabase
            .from('posts')
            .select('count', { count: 'exact', head: true });
        if (error) {
            console.error('Supabase connection test failed:', error);
            console.error('Error details:', {
                message: error.message,
                details: error.details,
                hint: error.hint,
                code: error.code,
            });
        }
        else {
            console.log('Supabase connection successful. Posts count:', count);
        }
    }
    catch (networkError) {
        console.error('Network error during Supabase connection test:', networkError);
        console.error('This might be a CORS issue. Please check:');
        console.error('1. Supabase project settings -> API -> Site URL includes http://localhost:5173');
        console.error('2. Your .env file has correct VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY');
        console.error('3. Your Supabase project is active and accessible');
    }
})();
